/**
 * @generated SignedSource<<7cda445feec90e136754e15be5ed5b51>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateAccountRequest = {
  featureFlagIds?: ReadonlyArray<string> | null;
  id: string;
  metaBusinessAccountId?: string | null;
  name?: string | null;
  ownerId?: string | null;
};
export type AccountFormDialogUpdateMutation$variables = {
  input: UpdateAccountRequest;
};
export type AccountFormDialogUpdateMutation$data = {
  readonly updateAccount: {
    readonly id: string;
  };
};
export type AccountFormDialogUpdateMutation = {
  response: AccountFormDialogUpdateMutation$data;
  variables: AccountFormDialogUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminAccount",
    "kind": "LinkedField",
    "name": "updateAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountFormDialogUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountFormDialogUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "910dbb77fa5b2586e4df1e6970098d9d",
    "id": null,
    "metadata": {},
    "name": "AccountFormDialogUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation AccountFormDialogUpdateMutation(\n  $input: UpdateAccountRequest!\n) {\n  updateAccount(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "384b988285d47477b31fd06c70736da0";

export default node;
